"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var ButtonGroup_1 = __importDefault(require("@mui/material/ButtonGroup"));
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableBody_1 = __importDefault(require("@mui/material/TableBody"));
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
var TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
var TableHead_1 = __importDefault(require("@mui/material/TableHead"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var mountIsland_1 = require("../mountIsland");
// ─── Component ────────────────────────────────────────────────────────────────
var FaqIndex = function () {
    var _a = (0, react_1.useState)([]), faqs = _a[0], setFaqs = _a[1];
    var _b = (0, react_1.useState)('en'), locale = _b[0], setLocale = _b[1];
    var _c = (0, react_1.useState)('all'), type = _c[0], setType = _c[1];
    // Initialize filters from URL params on component mount
    (0, react_1.useEffect)(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var urlLocale = urlParams.get('locale');
        var urlType = urlParams.get('type');
        if (urlLocale && ['en', 'es'].includes(urlLocale)) {
            setLocale(urlLocale);
        }
        if (urlType && ['all', 'text', 'video'].includes(urlType)) {
            setType(urlType);
        }
    }, []);
    // Update URL when filters change to maintain state
    (0, react_1.useEffect)(function () {
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.set('locale', locale);
        currentParams.set('type', type);
        var newUrl = "".concat(window.location.pathname, "?").concat(currentParams.toString());
        window.history.replaceState({}, '', newUrl);
    }, [locale, type]);
    (0, react_1.useEffect)(function () {
        var data = window.__INITIAL_FAQ_DATA__ || [];
        setFaqs(data);
    }, []);
    var filteredFaqs = faqs.filter(function (faq) {
        var matchesLocale = faq.locale === locale;
        var matchesType = type === 'all' ? true :
            type === 'video' ? faq.is_video :
                !faq.is_video;
        return matchesLocale && matchesType;
    });
    var localeOptions = ['en', 'es'];
    var typeOptions = ['all', 'text', 'video'];
    return (react_1.default.createElement(Box_1.default, { sx: { py: 2 } },
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'flex-end', mb: 3 } },
            react_1.default.createElement(Button_1.default, { variant: "contained", color: "warning", size: "large", href: "/app/admin/faqs/create", sx: { px: 4, py: 1 } }, "Create New FAQ")),
        react_1.default.createElement(Box_1.default, { sx: { mb: 3, display: 'flex', alignItems: 'center', gap: 3 } },
            react_1.default.createElement(ButtonGroup_1.default, { size: "large" }, localeOptions.map(function (loc) { return (react_1.default.createElement(Button_1.default, { key: loc, onClick: function () { return setLocale(loc); }, variant: locale === loc ? 'contained' : 'outlined', color: "primary", sx: { minWidth: 100 } }, loc.toUpperCase())); })),
            react_1.default.createElement(ButtonGroup_1.default, { size: "large" }, typeOptions.map(function (t) { return (react_1.default.createElement(Button_1.default, { key: t, onClick: function () { return setType(t); }, variant: type === t ? 'contained' : 'outlined', color: "secondary", sx: { minWidth: 100 } }, t.charAt(0).toUpperCase() + t.slice(1))); }))),
        react_1.default.createElement(TableContainer_1.default, { component: Paper_1.default },
            react_1.default.createElement(Table_1.default, null,
                react_1.default.createElement(TableHead_1.default, null,
                    react_1.default.createElement(TableRow_1.default, null,
                        react_1.default.createElement(TableCell_1.default, null, "ID"),
                        react_1.default.createElement(TableCell_1.default, null, "Question"),
                        react_1.default.createElement(TableCell_1.default, null, "Locale"),
                        react_1.default.createElement(TableCell_1.default, null, "Type"),
                        react_1.default.createElement(TableCell_1.default, null, "Sort"),
                        react_1.default.createElement(TableCell_1.default, null, "Active"),
                        react_1.default.createElement(TableCell_1.default, null, "Actions"))),
                react_1.default.createElement(TableBody_1.default, null, filteredFaqs.map(function (faq) { return (react_1.default.createElement(TableRow_1.default, { key: faq.id },
                    react_1.default.createElement(TableCell_1.default, null, faq.id),
                    react_1.default.createElement(TableCell_1.default, null, faq.question.length > 60
                        ? faq.question.slice(0, 60) + '…'
                        : faq.question),
                    react_1.default.createElement(TableCell_1.default, null, faq.locale),
                    react_1.default.createElement(TableCell_1.default, null, faq.is_video ? 'Video' : 'Text'),
                    react_1.default.createElement(TableCell_1.default, null, faq.sort_order),
                    react_1.default.createElement(TableCell_1.default, null, faq.is_active ? 'Yes' : 'No'),
                    react_1.default.createElement(TableCell_1.default, null,
                        react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", size: "small", href: "/app/admin/faqs/".concat(faq.id, "/edit?locale=").concat(locale, "&type=").concat(type), sx: { mr: 1 } }, "Edit"),
                        react_1.default.createElement(Box_1.default, { component: "form", action: "/app/admin/faqs/".concat(faq.id), method: "POST", sx: { display: 'inline' } },
                            react_1.default.createElement("input", { type: "hidden", name: "_method", value: "DELETE" }),
                            react_1.default.createElement("input", { type: "hidden", name: "_token", value: window.csrf_token }),
                            react_1.default.createElement(Button_1.default, { type: "submit", variant: "contained", color: "error", size: "small" }, "Delete"))))); }))))));
};
// ─── Mount directly from Blade ────────────────────────────────────────────────
var rootEl = document.getElementById('faq-index-root');
if (rootEl) {
    (0, mountIsland_1.mountIsland)(rootEl, react_1.default.createElement(FaqIndex, null));
}
